/**
 * Força a transformação de texto para Title Case nos itens do menu_new
 * Isso resolve o problema onde text-transform: capitalize não funciona
 * quando o texto vem em MAIÚSCULAS do HTML
 */

(function() {
  function transformMenuText() {
    const menuContainer = document.querySelector('.menu_new');
    const menuItems = document.querySelectorAll('.menu_new .header__menu-item span');
    
    menuItems.forEach(function(item) {
      // Pega o texto atual
      const text = item.textContent || item.innerText;
      
      // Converte para Title Case (primeira letra de cada palavra maiúscula, resto minúsculo)
      const titleCase = text
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      
      // Atualiza o texto do elemento
      item.textContent = titleCase;
    });
    
    // Marca o menu como pronto para exibição
    if (menuContainer) {
      menuContainer.classList.add('menu_new--ready');
    }
  }
  
  // Executa assim que o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', transformMenuText);
  } else {
    // DOM já está pronto, executa imediatamente
    transformMenuText();
  }
})();
